import React, { Component } from 'react'
import * as s from './ThirdQuestion.module.css'
import Button from '../../ui/Button'
import { StaticImage } from 'gatsby-plugin-image'

export default class ThirdQuestion extends Component {
    constructor(props){
        super(props);
        this.state = { 
            checkedJa: false ,
            checkedNein: false ,
        }

    }
    onClickCheckbox = (event) => { 
    this.setState({ checked: event.target.checked })}
    
    render() {
        return (
            <div className={s.wrapper}>
            <div className={s.content}>
                <h1 className={s.headline}>Sind Sie Hersteller oder vertreiben Sie Produkte?</h1>
            </div>
            <div className={s.ChekboxContainer}>
                <div  checked={this.state.checkedJa} onClick={this.onClickCheckbox}
                     className={`${s.chekboxAllStyle} ${s.chekbox1}`}> 
                    <StaticImage className={s.icon} src="../../../images/ja.png" alt="Hersteller"/>
                    <h2 className={s.subtitle}> Ja</h2>
                </div>
                <div checked={this.state.checkedNein} onClick={this.onClickCheckbox}
                 className={`${s.chekboxAllStyle} ${s.chekbox2}`}> 
                    <StaticImage className={s.icon} src="../../../images/nein.png" alt="Produktvertrieb"/>
                    <h2 className={s.subtitle}> Nein</h2>
                </div>
            </div>
            <Button buttonText="weiter"/>
        </div>
        )
    }
}
